module.exports = __webpack_public_path__ + "img/onze-dekreu2.0e6e48d6.jpg";